import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { map, Observable } from 'rxjs';

import { IContractArrayInput, IContractInput } from 'src/app/models/contract';
import { Inputs } from 'src/app/shared/utils/base';
import { ApiContractService } from '../api/api-contract.service';

@Injectable({
  providedIn: 'root'
})
export class ContractResolver
  implements
  Resolve<{ [key: string]: IContractInput[] | IContractArrayInput[] }>
{
  constructor(private _contractService: ApiContractService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<{ [key: string]: IContractInput[] | IContractArrayInput[] }> {
    const contractNumber = route.params['contractNumber'];
    const queryNumber = route.params['queryNumber'];
    const financialInstitution = route.params['financialInstitution'];
    const contractInfo = Inputs;
    const getById: string = route.queryParams['byId'];
    return this._contractService
      .initializeForm(contractNumber, queryNumber, financialInstitution, getById === 'true')
      .pipe(
        map((contractForm) => {
          return contractInfo;
        })
      );
  }
}
